/** @mui/material imports */
import Chip from '@mui/material/Chip/Chip';
import { grey } from '@mui/material/colors';
/** @mui/icons-material imports */
/** React imports */
import React from 'react';
import { useTranslation } from 'react-i18next';
/** App imports */

export const SidebarStepBadge: React.FC<{ step: string }> = ({
  step,
}): JSX.Element => {
  const { t } = useTranslation();

  /**
   * Chips used in the sidebar
   */
  const badgeConfig: Record<string, string> = {
    'coming-soon': t('LABEL_BADGE_COMING_SOON'),
    'not-included': t('LABEL_BADGE_NOT_INCLUDED'),
  };

  const label: string = badgeConfig[step];

  return label ? (
    <Chip
      component="span"
      label={label}
      color="default"
      size="small"
      variant="filled"
      sx={{
        height: '20px',
        backgroundColor: grey[600],
        color: 'white',
        'span.MuiChip-label': {
          fontSize: '12px',
        },
      }}
    />
  ) : (
    <></>
  );
};
